import { Component, Input, inject } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-offcanvas-header-btn',
  imports: [],
  template: `
    <button
      id="offcanvasNavigateBack"
      (click)="navigateBack()"
      class="offcanvas-title-btn">
      <i class="iconoir-nav-arrow-left"></i>
      {{ title }}
    </button>
  `,
})
export class OffcanvasHeaderBtnComponent {
  readonly location = inject(Location);

  @Input() title!: string;
  navigateBack() {
    this.location.back();
  }
}
